// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8384":"css/app.6920","9937":"css/admin-app.6920"}[chunkId] + ".css";
};